import { Box } from "@mui/system";
import React from "react";
import styled from "styled-components";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';


const UserManual = () => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const theme = useTheme();
  const isBelow768 = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Wrapper>
    
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.js">
        <div style={{ height: '750px',marginTop:'-20px' }}>
            <Viewer
                fileUrl={`${process.env.PUBLIC_URL}/assets/User-manual.pdf`}
                plugins={[
                    defaultLayoutPluginInstance,
                ]}
                hideToolbar={true}
                className="pdf-viewer"
            />
        </div>
    </Worker>
    </Wrapper>
  );
};

const Wrapper = styled.div`
.rpv-default-layout__toolbar,.rpv-default-layout__sidebar {
  display: none;
}
.rpv-default-layout__body{
  padding-top: 0px;
}
.pdf-viewer{
  margin-top: -20px;
}
 
`;
export default UserManual;
